import { Controller } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails"

export default class extends Controller {
  static targets = ["select", "dateRange", "from", "to"]

  change() {
    const period = this.selectTarget.value

    if (period === "custom") {
      this.dateRangeTarget.classList.remove("hidden")
      return
    }

    this.dateRangeTarget.classList.add("hidden")
    Turbo.visit(`${window.location.pathname}?period=${period}`, { frame: "sales_chart" })
  }

  apply() {
    const from = this.#toISO(this.fromTarget.value)
    const to = this.#toISO(this.toTarget.value)
    const params = new URLSearchParams({ period: "custom" })
    if (from) params.set("from", from)
    if (to) params.set("to", to)
    Turbo.visit(`${window.location.pathname}?${params}`, { frame: "sales_chart" })
  }

  // Convert "dd/mm/yyyy" to "yyyy-mm-dd"
  #toISO(value) {
    if (!value) return ""
    const parts = value.split("/")
    if (parts.length !== 3) return value
    return `${parts[2]}-${parts[1]}-${parts[0]}`
  }
}
